'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.createActions = exports.createActionType = exports.createAction = void 0;
var tslib_1 = require('tslib');
var getKeys_1 = require('./getKeys');
// implementation
function createAction(type, getPayload) {
    var actionCreator = getPayload
        ? function () {
              var actionArgs = [];
              for (var _i = 0; _i < arguments.length; _i++) {
                  actionArgs[_i] = arguments[_i];
              }
              return {
                  type: type,
                  payload: getPayload.apply(
                      void 0,
                      (0, tslib_1.__spreadArray)([], (0, tslib_1.__read)(actionArgs), false)
                  ),
              };
          }
        : function (payload) {
              return {
                  type: type,
                  payload: payload,
              };
          };
    return Object.assign(actionCreator, {
        toString: function () {
            return type;
        },
    });
}
exports.createAction = createAction;
function createActionType(apiString, methodKey) {
    var apiWords = apiString.replace(/([a-z])([A-Z])/g, '$1 $2').split(' ');
    var methodWords = methodKey.replace(/([a-z])([A-Z])/g, '$1 $2').split(' ');
    return apiWords.concat(methodWords).join('_').toUpperCase();
}
exports.createActionType = createActionType;
function createActions(source, postfix) {
    // takes only public methods (private starts with _)
    var methodsKeys = (0, getKeys_1.getClassMethods)(source);
    function keyReducer(actions, methodKey) {
        var type = createActionType(source.toString(), methodKey);
        var fullType = postfix !== undefined ? ''.concat(type, '_').concat(postfix) : type;
        actions[methodKey] = createAction(fullType, function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return args;
        });
        return actions;
    }
    return methodsKeys.reduce(keyReducer, {});
}
exports.createActions = createActions;
